import { render, staticRenderFns } from "./ParticipantClaimsSortBy.vue?vue&type=template&id=710e24d1&scoped=true"
import script from "./ParticipantClaimsSortBy.vue?vue&type=script&lang=js"
export * from "./ParticipantClaimsSortBy.vue?vue&type=script&lang=js"
import style0 from "./ParticipantClaimsSortBy.vue?vue&type=style&index=0&id=710e24d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e24d1",
  null
  
)

export default component.exports